import { render, staticRenderFns } from "./BigDataConfigCard.vue?vue&type=template&id=4134b628&scoped=true&"
import script from "./BigDataConfigCard.vue?vue&type=script&lang=js&"
export * from "./BigDataConfigCard.vue?vue&type=script&lang=js&"
import style0 from "./BigDataConfigCard.vue?vue&type=style&index=0&id=4134b628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134b628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VRow,VSnackbar})
